export const COLORS = {
  transparent: "transparent",
  current: "currentColor",
  white: "#FFFFFF",
  base: {
    black: "#020F1F",
    white: "#FFFFFF",
    green: "#24A546",
    red: "#EB5A74",
    orange: "#FF994F",
    light: {
      grey: "#F5F6F8",
      black: "#273A51",
    },
  },
  background: {
    grey: "#FAFBFC",
  },
  notification: {
    red: "#DC143C",
  },
  green: {
    dark: "#094A1A",
    hover: "#B5DABF",
    light: "#D2F4DB",
  },
  blue: {
    dark: "#0E3566",
    hover: "#D7E3F2",
    light: "#EBF4FF",
  },
  purple: {
    dark: "#680868",
    hover: "#FAC6FA",
    light: "#FFE6FF",
  },
  violet: {
    dark: "#5B0458",
    light: "#C9B1F5",
    hover: "#C9B1F5",
  },
  grey: {
    dark: "#7B8490",
    hover: "#BEC9D4",
    light: "#DDE3EA",
  },
  red: {
    dark: "#7C2024",
    hover: "#E8CBCC",
    light: "#FFE6E7",
    pastel: "#FFCDD2",
  },
  yellow: {
    dark: "#7A5B00",
    hover: "#ffeebe",
    light: "#FFF8B5",
  },
  orange: {
    dark: "#643607",
    hover: "#ffdabe",
    light: "#FFDDA1",
  },
  paleSky: {
    dark: "#043F4E",
    light: "#B3E5FC",
  },
  budget: {
    green: {
      base: "#6FCF97",
      hover: "#236D4A",
    },
    purple: {
      base: "#7082E5",
      hover: "#0E3566",
    },
    blue: {
      base: "#D1E5FE",
      hover: "#0E3566",
    },
    darkBlue: {
      base: "#88bcfd",
      hover: "#002D62",
    },
  },
};
